import React, {useState} from "react";
import {
    Box, Typography, TextField, Button, InputAdornment, Divider, useMediaQuery
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useOutletContext, useParams } from "react-router-dom";
import { esignIcons } from "../../components/Esign/icons";
import { useSelector } from 'react-redux';
import VisitAdmin from "../../components/VisitAdmin";
import Cookies from "js-cookie";

const Product = () => {
    const { open } = useOutletContext();
    const { product } = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const rawItems = useSelector((state) => state.products.rawItems);
    const token = Cookies.get("_d_token");
    const productData = rawItems.find((item) => item.product_name.toLowerCase() === product.toLowerCase());
    // console.log(productData);
    return (
      <Box
        sx={{
          flexGrow: 1,
          p: isMobile ? 2 : 3,
          width: isMobile ? "100%" : open ? "calc(100% - 280px)" : "calc(100% - 100px)",
          marginLeft: isMobile ? "0" : open ? "280px" : "100px",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
        }}
      >
        <Box mt={10} style={{ borderRadius: "12px", textAlign: "center", background: "#fff", width: "100%", height: "calc(100% - 73px)", marginLeft: open ? "" : "1em", }} >
            <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: isMobile ? "15px 10px" : "25px" }}>
                <Typography sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D",}}>
                    {productData?.product_name}
                </Typography>
                {(!token && productData?.sso_path && productData?.sso_path?.toLowerCase()!=='none') && (<VisitAdmin productData={productData} />)}
            </Box>
            <Divider />
            <Box sx={{ p: "15px 0px", overflow: "auto", height: "calc(100% - 96px)"}}>
                <Box sx={{ fontSize: "15px", textAlign: "left" }} dangerouslySetInnerHTML={{ __html: productData?.documentation }}/>
            </Box>
        </Box>
      </Box>
    );
};

export default Product;
